@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/shared/components/glass-house-brands/glass-house-description/glass-house-description.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  display: contents;
}
:host .glass-house-description {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
}
:host .glass-house-description span {
  font-family: onest, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 0.625rem;
  line-height: 160%;
  letter-spacing: 0.8px;
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-align: center;
}
/*# sourceMappingURL=glass-house-description.component.css.map */
